module.exports = __webpack_public_path__ + "static/gond-DND3_FnP-5fc61373b23105cf33465aa1ed8858c2.webp";